"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.XlsxExtraction = void 0;
const common_1 = require("@finley-technologies/common");
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
const _1 = require(".");
const typeguards = __importStar(require("../typeguards"));
const findDirectDependencies = (graph, artifactId, configPredicate) => {
    return graph.dependencies
        .filter(({ inputArtifactId }) => inputArtifactId === artifactId)
        .map(({ outputArtifactId }) => {
        const outputArtifact = graph.artifacts.find(({ id }) => id === outputArtifactId);
        if (!outputArtifact || !configPredicate(outputArtifact.configuration)) {
            return null;
        }
        // This redundant object spread converts ArtifactWithSlugs to TypedArtifact.
        return { ...outputArtifact, configuration: outputArtifact.configuration };
    })
        .filter(common_1.typeguards.isNotNullOrUndefined);
};
// TODO(jon): rename this file - it's not xlsx specific anymore.
var XlsxExtraction;
(function (XlsxExtraction) {
    const getFieldGroup = ({ xlsx2CsvArtifact, sanitizeArtifact, }) => {
        const xlsxConfig = xlsx2CsvArtifact?.configuration;
        const sanitizeConfig = sanitizeArtifact.configuration;
        // `sanitizeConfig.baseFields` and the `ColumnInfo`s we derive from it use the original field
        // name formatting from the tape, which is clearest to present to the user. Elsewhere, we may
        // use reformatted ("sanitized") field names. For simplicity, always sanitize before comparing
        // field names, even when technically not necessary.
        const sanitizeFieldNames = !sanitizeConfig.doNotSanitizeFieldNames;
        switch (xlsxConfig?.mode) {
            case 'extractValues': {
                const columns = xlsxConfig.extract
                    .map(({ sheetName, cellAddress, fieldName }) => {
                    const sanitizeField = sanitizeConfig.baseFields.find(({ field }) => 
                    // Although it is a best practice for the xlsxConfig and sanitizeConfig field names
                    // to match exactly, this is not enforced. To be safe, sanitize both names before
                    // performing comparison.
                    (0, tape_sanitizer_1.getSanitizedFieldName)(field, sanitizeFieldNames) ===
                        (0, tape_sanitizer_1.getSanitizedFieldName)(fieldName, sanitizeFieldNames));
                    return sanitizeField
                        ? { ...(0, tape_sanitizer_1.toColumnInfo)(sanitizeField), sheetName, cellAddress }
                        : null;
                })
                    .filter(common_1.typeguards.isNotNullOrUndefined);
                return {
                    mode: 'extractValues',
                    dataTapeSlug: sanitizeArtifact.artifactSlug,
                    columns,
                    xlsx2CsvArtifact: common_1.utils.ensure(xlsx2CsvArtifact),
                    sanitizeArtifact,
                };
            }
            case 'convertRange': {
                const { sheetName, headerRange } = xlsxConfig;
                const columns = sanitizeConfig.baseFields.map(tape_sanitizer_1.toColumnInfo);
                return {
                    mode: 'extractTape',
                    dataTapeSlug: sanitizeArtifact.artifactSlug,
                    sheetName,
                    headerRange,
                    columns,
                    xlsx2CsvArtifact: common_1.utils.ensure(xlsx2CsvArtifact),
                    sanitizeArtifact,
                };
            }
            case undefined: {
                const columns = sanitizeConfig.baseFields.map(tape_sanitizer_1.toColumnInfo);
                return {
                    mode: 'csv',
                    dataTapeSlug: sanitizeArtifact.artifactSlug,
                    columns,
                    xlsx2CsvArtifact: null,
                    sanitizeArtifact,
                };
            }
            default:
                throw (0, common_1.finleyAssertUnreachable)(xlsxConfig);
        }
    };
    const getSanitizeReachableByPrefilter = (graph, startingArtifactIds) => 
    // In the most common case, we have
    // raw node -> (optional: xlsx2csv ->) sanitize node
    //
    // however, in some cases we have
    // raw node -> (optional: xlsx2csv ->) prefilter node -> prefilter node ... -> sanitize node
    //
    // Since prefilter only filters out rows, but does not change the field definitions, it's
    // correct to say that the sanitize node describe the raw tape, even when there are prefilter
    // nodes between them.
    _1.BbplGraph.traverseBreadthFirst(graph, startingArtifactIds, ({ artifacts }, artifactId) => {
        const artifact = artifacts.find(({ id }) => id === artifactId);
        if (typeguards.isTapeBuilderPreFilterTask(artifact?.configuration)) {
            return _1.BbplGraph.getDependants(graph, artifactId);
        }
        return [];
    })
        .map((artifact) => 
    // This redundant object spread converts PartialArtifact to PartialArtifact<TapeBuilderSanitizeTask>.
    typeguards.isTapeBuilderSanitizeTask(artifact.configuration)
        ? { ...artifact, configuration: artifact.configuration }
        : null)
        .filter(common_1.typeguards.isNotNullOrUndefined);
    /**
     * Returns groups of fields extracted from an xlsx.
     *
     * The list is pre-sorted in a reasonable display order.
     *
     * If an empty list is returned, `rawArtifactId` is not configured for xlsx extraction. In other
     * words, it can be assumed that the raw artifact is not an xlsx file.
     */
    XlsxExtraction.getXlsxFieldGroups = (graph, rawArtifactId) => {
        const xlsxArtifacts = findDirectDependencies(graph, rawArtifactId, typeguards.isTapeBuilderXlsx2CsvTask);
        return xlsxArtifacts
            .flatMap((xlsx2CsvArtifact) => {
            const dependantIds = _1.BbplGraph.getDependants(graph, xlsx2CsvArtifact.id);
            return getSanitizeReachableByPrefilter(graph, dependantIds).map((sanitizeArtifact) => getFieldGroup({ xlsx2CsvArtifact, sanitizeArtifact }));
        })
            .sort(({ xlsx2CsvArtifact: xlsxA, sanitizeArtifact: sanitizeA }, { xlsx2CsvArtifact: xlsxB, sanitizeArtifact: sanitizeB }) => {
            (0, common_1.finleyAssert)(xlsxA && xlsxB, 'expected xlsx field group');
            // For each xlsx, show extractValues ahead of extractTape.
            if (xlsxA.configuration.mode !== xlsxB.configuration.mode)
                return xlsxA.configuration.mode === 'extractValues' ? -1 : 1;
            // Order doesn't matter, as long as it's consistent.
            return sanitizeA.artifactSlug.localeCompare(sanitizeB.artifactSlug);
        });
    };
    XlsxExtraction.getCsvFieldGroups = (graph, rawArtifactId) => {
        const dependantIds = _1.BbplGraph.getDependants(graph, rawArtifactId);
        return getSanitizeReachableByPrefilter(graph, dependantIds)
            .map((sanitizeArtifact) => getFieldGroup({ xlsx2CsvArtifact: null, sanitizeArtifact }))
            .sort(({ sanitizeArtifact: sanitizeA }, { sanitizeArtifact: sanitizeB }) => sanitizeA.artifactSlug.localeCompare(sanitizeB.artifactSlug));
    };
})(XlsxExtraction || (exports.XlsxExtraction = XlsxExtraction = {}));
//# sourceMappingURL=xlsx.js.map